import React from 'react';
import PropTypes from 'prop-types';

import Error404 from '@andes/technical-error/build/presets/Error404';

import { MOTORS_CATALOG_BU } from '../../../../../constants/businessUnitConstants';
import { VERSION_PAGE_TYPE } from '../../../../../constants/pageTypeConstants';
import { getServerSideProps as getProps } from '../../../../../hooks/landing/buildProps';
import Landing from '../../../../ui-components/landing';

const Catalog = (props) => {
  const {
    device,
    landingData,
    jsDisabled,
    supportWebP,
    notFoundError,
    melidata,
  } = props;

  if (notFoundError) {
    return <Error404 />;
  }

  return (
    <Landing
      device={device}
      landingData={landingData}
      jsDisabled={jsDisabled}
      supportWebP={supportWebP}
      melidata={melidata}
    />
  );
};

export const getServerSideProps = async (req, res) =>
  getProps(req, res, MOTORS_CATALOG_BU, VERSION_PAGE_TYPE);

export const setPageSettings = ({ settings }) => ({
  ...settings,
});

Catalog.propTypes = {
  device: PropTypes.string.isRequired,
  jsDisabled: PropTypes.bool.isRequired,
  supportWebP: PropTypes.bool.isRequired,
  notFoundError: PropTypes.bool.isRequired,
  melidata: PropTypes.shape({
    user_type: PropTypes.string,
    logged: PropTypes.bool,
    business_unit: PropTypes.string.isRequired,
    page_type: PropTypes.string.isRequired,
    brand: PropTypes.string,
    model: PropTypes.string,
    year: PropTypes.string,
    version: PropTypes.string,
  }).isRequired,
  landingData: PropTypes.shape({
    metadata: PropTypes.shape({
      title: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
    }).isRequired,
    components: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  }),
};

export default Catalog;
